import React, { useState, useEffect } from 'react';
import { Row, Col, FormGroup, Input, Button, Label } from 'reactstrap';
import { useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { URL } from '../../api';
import axiosInstance from "../../Request";
import 'react-toastify/dist/ReactToastify.css';
import getPrivilegeList from "../../PrivilegeList";
const NomineeDetails = ({ customerDetails, disableEdit }) => {
  const { cid, lid } = useParams();
const privilegeList = getPrivilegeList();
  const [editableDetails, setEditableDetails] = useState({
    nomineeName: "-NA-",
    nomineeDob: "-NA-",
    nomineeGender: null,
  });

  const [initialDetails, setInitialDetails] = useState({
    nomineeName: "-NA-",
    nomineeDob: "-NA-",
    nomineeGender: null,
  });

  const [isEditable, setIsEditable] = useState(false);
  const [changedFields, setChangedFields] = useState({});

  useEffect(() => {
    if (customerDetails && customerDetails.nominee) {
      const details = customerDetails.nominee;
      const formattedDetails = {
        nomineeName: details.nomineeName || "-NA-",
        nomineeDob: details.nomineeDob || "-NA-",
        nomineeGender: details.nomineeGender ?? null,
      };
      setEditableDetails(formattedDetails);
      setInitialDetails(formattedDetails);
    }
  }, [customerDetails]);

 const handleInputChange = (e) => {
  const { name, value } = e.target;
  const newValue = name === "nomineeGender" ? parseInt(value) : value;

  setEditableDetails((prevState) => ({
    ...prevState,
    [name]: newValue,
  }));

  setChangedFields((prevState) => ({
    ...prevState,
    [name]: true,
  }));
};


  const handleGenderChange = (value) => {
    setEditableDetails((prevState) => ({
      ...prevState,
      nomineeGender: value,
    }));
    setChangedFields((prevState) => ({
      ...prevState,
      nomineeGender: true,
    }));
  };

  const handleEditClick = () => {
    setIsEditable(true);
  };

  const handleCancelClick = () => {
    setEditableDetails({ ...initialDetails });
    setIsEditable(false);
    setChangedFields({});
  };

  const handleUpdateClick = () => {
    const payload = { customer_id: cid, lead_id: cid };

    if (changedFields.nomineeName) {
      payload.nominee_name = editableDetails.nomineeName;
    }

    if (changedFields.nomineeDob) {
      const dobRegex = /^\d{4}-\d{2}-\d{2}$/;
      if (!dobRegex.test(editableDetails.nomineeDob)) {
        toast.warning("Invalid DOB format. Expected YYYY-MM-DD.");
        return;
      }
      payload.nominee_dob = editableDetails.nomineeDob;
    }
      if (changedFields.nomineeGender) {
       payload.nominee_gender = editableDetails.nomineeGender;

      }
    if (Object.keys(payload).length === 1) {
      toast.warning("No changes to update.");
      return;
    }

    updateNomineeDetails(payload);
    setIsEditable(false);
    setChangedFields({});
  };

  const updateNomineeDetails = async (payload) => {
    console.log('Sending nominee payload:', payload);

    try {
      const response = await axiosInstance.post(URL.UPDATE_NOMINEE_DETAILS, payload);
      const result = response.data;
      toast.success(result.message || "Nominee details updated successfully");
    } catch (error) {
      const errorMsg = error?.response?.data?.message || "Nominee details update failed";
      toast.warning(errorMsg);
    }
  };

  return (
    <div className="nominee-details">
      <h6 className="heading-small text-muted mb-4">Nominee</h6>
      <div className="pl-lg-4">
        <Row>
          <Col lg="6">
            <FormGroup>
              <label className="form-control-label">Name</label>
              <Input
                className="form-control-alternative"
                type="text"
                name="nomineeName"
                value={editableDetails.nomineeName}
                onChange={handleInputChange}
                disabled={!isEditable}
              />
            </FormGroup>
          </Col>

          <Col lg="6">
            <FormGroup>
              <label className="form-control-label">Nominee DOB</label>
              <Input
                className="form-control-alternative"
                type="text"
                name="nomineeDob"
                value={editableDetails.nomineeDob}
                onChange={handleInputChange}
                disabled={!isEditable}
              />
            </FormGroup>
          </Col>

          <Col lg="6">
            <FormGroup>
  <label className="form-control-label">Gender</label>

  <div className="form-check">
    <input
      type="radio"
      id="gender-male"
      name="nomineeGender"
      value={1}
      className="form-check-input form-control-alternative"
      checked={editableDetails.nomineeGender === 1}
      onChange={handleInputChange}
      disabled={!isEditable}
    />
    <label htmlFor="gender-male" className="form-check-label">Male</label>
  </div>

  <div className="form-check">
    <input
      type="radio"
      id="gender-female"
      name="nomineeGender"
      value={2}
      className="form-check-input form-control-alternative"
      checked={editableDetails.nomineeGender === 2}
      onChange={handleInputChange}
      disabled={!isEditable}
    />
    <label htmlFor="gender-female" className="form-check-label">Female</label>
  </div>

  <div className="form-check">
    <input
      type="radio"
      id="gender-other"
      name="nomineeGender"
      value={3}
      className="form-check-input form-control-alternative"
      checked={editableDetails.nomineeGender === 3}
      onChange={handleInputChange}
      disabled={!isEditable}
    />
    <label htmlFor="gender-other" className="form-check-label">Other</label>
  </div>
</FormGroup>

          </Col>

          {privilegeList?.nomineeDetailsEdit &&  !disableEdit && (
            <Col className="text-right" xs="12">
              {!isEditable ? (
                <Button color="primary" size="sm" onClick={handleEditClick}>
                  Edit
                </Button>
              ) : (
                <>
                  <Button color="secondary" size="sm" onClick={handleCancelClick}>
                    Cancel
                  </Button>
                  <Button color="primary" size="sm" onClick={handleUpdateClick}>
                    Update
                  </Button>
                </>
              )}
            </Col>
          )}
        </Row>
      </div>
      <hr className="my-4" />
    </div>
  );
};

export default NomineeDetails;
